import { useNavigate } from "react-router-dom";

import { AdminButton } from "@/components/admin/button";
import { Card, CardBody, CardHead } from "@/components/admin/card";
import { AdminIcon } from "@/components/admin/icon";
import { PageHead } from "@/components/admin/page-head";
import { Tag } from "@/components/admin/tag";
import { useProviders, useTestProvider } from "@/hooks/use-payments";

export function AdminProvidersPage() {
	const navigate = useNavigate();
	const { data } = useProviders();
	const test = useTestProvider();
	const items = data ?? [];

	return (
		<>
			<PageHead
				title="Prestataires PSP"
				sub="Clés API en vault refs (jamais en clair) · routing primary/fallback"
				actions={
					<AdminButton variant="ghost" onClick={() => navigate("/paiements")}>
						<AdminIcon n="chevL" s={14} />
						Retour
					</AdminButton>
				}
			/>

			<Card style={{ marginBottom: 16 }}>
				<CardHead
					title={`Prestataires (${items.length})`}
					sub="Statuts des clés et routing"
				/>
				{items.length === 0 ? (
					<CardBody>
						<div className="empty">Aucun prestataire configuré.</div>
					</CardBody>
				) : (
					<div className="table-wrap" style={{ margin: 0 }}>
						<table className="table">
							<thead>
								<tr>
									<th>Code</th>
									<th>Label</th>
									<th>Type</th>
									<th>Primary</th>
									<th>Actif</th>
									<th>Vault refs</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								{items.map((p) => (
									<tr key={p.code}>
										<td className="mono">{p.code}</td>
										<td>{p.label}</td>
										<td>{p.kind}</td>
										<td>
											{p.is_primary ? (
												<Tag variant="success">Primary</Tag>
											) : (
												<Tag variant="neutral">Fallback</Tag>
											)}
										</td>
										<td>
											{p.is_active ? (
												<Tag variant="success">Actif</Tag>
											) : (
												<Tag variant="danger">Désactivé</Tag>
											)}
										</td>
										<td className="muted" style={{ fontSize: 12 }}>
											secret: {p.webhook_secret_set ? "✓" : "✗"} · key:{" "}
											{p.api_key_set ? "✓" : "✗"}
										</td>
										<td>
											<AdminButton
												variant="ghost"
												onClick={() =>
													test.mutate(p.code, {
														onSuccess: (r) =>
															alert(
																`${r.code} : ${r.operational ? "OPÉRATIONNEL ✅" : "NON OPÉRATIONNEL ❌"}`,
															),
														onError: (e) => {
															const err = e as {
																response?: { data?: { message?: string } };
																message: string;
															};
															alert(err.response?.data?.message ?? err.message);
														},
													})
												}
											>
												<AdminIcon n="check" s={12} />
												Tester
											</AdminButton>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				)}
			</Card>

			<Card>
				<CardHead
					title="Routing"
					sub="Stratégie primary / fallback et gestion des clés"
				/>
				<CardBody>
					<p className="muted" style={{ marginTop: 0, lineHeight: 1.6 }}>
						<strong>Mobile Money</strong> : NotchPay primary → fallback Campay
						(circuit-breaker 5 échecs / 30 s).
					</p>
					<p className="muted" style={{ marginTop: 8, lineHeight: 1.6 }}>
						<strong>Cartes</strong> : Stripe Elements (PCI-DSS SAQ-A) — aucune
						donnée PAN/CVV stockée.
					</p>
					<p className="muted" style={{ marginTop: 8, lineHeight: 1.6 }}>
						<strong>Sécurité</strong> : toutes les clés sont des références à
						des variables d'environnement (NOTCH_PAY_PRIVATE_API_KEY,
						STRIPE_SECRET_KEY, …) — aucune valeur n'est stockée en clair dans la
						base.
					</p>
				</CardBody>
			</Card>
		</>
	);
}
